import { __rest, __read, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import React__default, { forwardRef, useState, useEffect } from 'react';
import ReactDatePicker from 'react-datepicker';
import { useMediaQuery } from 'react-responsive';
import dfParse from 'date-fns/parse';
import { singleDateMasks, DATE_RANGE_SEPARATOR, DEFAULT_MASK_CHAR } from '../utils/maskTypes.esm.js';
import DateField from './DateField.esm.js';

var SMALL_MAX = 719;
var NvCalendar = forwardRef(function (_a, ref) {
    var classes = _a.classes, customInput = _a.customInput, _b = _a.format, format = _b === void 0 ? 'MM/dd/yyyy' : _b, hideInput = _a.hideInput, _c = _a.id, id = _c === void 0 ? 'nv-calendar' : _c, isDateRange = _a.isDateRange, maxDate = _a.maxDate, minDate = _a.minDate, onBlur = _a.onBlur, onCalendarOpen = _a.onCalendarOpen, placeholder = _a.placeholder, onChange = _a.onChange, value = _a.value, disabled = _a.disabled, showTime = _a.showTime, props = __rest(_a, ["classes", "customInput", "format", "hideInput", "id", "isDateRange", "maxDate", "minDate", "onBlur", "onCalendarOpen", "placeholder", "onChange", "value", "disabled", "showTime"]);
    var _d = __read(useState([null, null]), 2), dates = _d[0], setDates = _d[1];
    var _e = __read(dates, 2), startDate = _e[0], endDate = _e[1];
    var isMobile = useMediaQuery({
        maxWidth: SMALL_MAX,
    });
    var supportsManualEntries = singleDateMasks.includes(format.toUpperCase());
    var defaultPlaceholder = isDateRange
        ? "".concat(format.toUpperCase()).concat(DATE_RANGE_SEPARATOR).concat(format.toUpperCase())
        : format.toUpperCase();
    var placeholderText = placeholder !== null && placeholder !== void 0 ? placeholder : defaultPlaceholder;
    var handleDateRangeChange = function (values) {
        if (!isDateRange)
            return;
        setDates(function () {
            var _a = __read(values, 2), newStartDate = _a[0], newEndDate = _a[1];
            if (!newEndDate)
                return [newStartDate, newEndDate];
            // onChange is called only when both dates are selected
            onChange(values);
            return [newStartDate, newEndDate];
        });
    };
    var onChangeRaw = function (e) {
        var _a;
        var rawValue = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value;
        if (!supportsManualEntries || !rawValue)
            return;
        var hasNumbers = rawValue.replace(/[^\d]/g, '');
        if (!hasNumbers) {
            // empty field
            return value && onChange(null);
        }
        if (isDateRange) {
            var _b = __read(rawValue.split(DATE_RANGE_SEPARATOR), 2), start = _b[0], end = _b[1];
            var startComplete = !(start === null || start === void 0 ? void 0 : start.includes(DEFAULT_MASK_CHAR));
            var endComplete = !(end === null || end === void 0 ? void 0 : end.includes(DEFAULT_MASK_CHAR));
            if (startComplete && endComplete) {
                var newDates = [dfParse(start, format, new Date()), dfParse(end, format, new Date())];
                onChange(newDates);
            }
        }
    };
    /**
     * This useEffect allows the component to receive value as a prop
     * while still keeping a local state to control when onChange is called.
     *
     * This applies only when isDateRange is passed.
     */
    useEffect(function () {
        setDates(isDateRange ? value || [null, null] : [value || null, null]);
    }, [isDateRange, value]);
    var baseProps = {
        calendarClassName: 'nv-calendar',
        customInput: customInput || (React__default.createElement(DateField, __assign({}, props, { alwaysShowMask: false, className: classes === null || classes === void 0 ? void 0 : classes.field, "data-testid": "input", isDateRange: isDateRange, isInputDisabled: disabled, maskType: supportsManualEntries ? defaultPlaceholder : undefined }))),
        dateFormat: format,
        dayClassName: function () { return 'nv-calendar-day'; },
        id: id,
        inline: hideInput,
        maxDate: maxDate,
        minDate: minDate,
        onBlur: onBlur,
        onCalendarOpen: onCalendarOpen,
        onChangeRaw: onChangeRaw,
        placeholderText: placeholderText,
        ref: ref,
        selected: startDate,
        showPopperArrow: false,
        showTimeInput: showTime,
    };
    return (React__default.createElement("div", { className: classes === null || classes === void 0 ? void 0 : classes.root }, isDateRange ? (React__default.createElement(ReactDatePicker, __assign({}, baseProps, { endDate: endDate, monthsShown: isMobile ? 1 : 2, onChange: handleDateRangeChange, selectsRange: true, startDate: startDate }))) : (React__default.createElement(ReactDatePicker, __assign({}, baseProps, { onChange: function (value) { return onChange(value || null); } })))));
});

export { NvCalendar as default };
//# sourceMappingURL=NvCalendar.esm.js.map
